const normalizeApiPath = (path) => {
    if (!path) return '/';
    return path.startsWith('/') ? path : `/${path}`;
};

let cachedAuthToken = null;
let cachedJwtCookieValue = null;
let tokenRequestPromise = null;

export const useDirectApiUrl = (path) => {
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.API_URL || '';
    const normalizedPath = normalizeApiPath(path);

    if (!baseUrl) {
        return normalizedPath;
    }

    return `${baseUrl}${normalizedPath}`;
};

const useDirectApiAuthToken = async () => {
    if (!import.meta.client) {
        return null;
    }

    const jwtCookie = useCookie('jwt');
    const currentJwtCookieValue = jwtCookie.value || null;

    if (!currentJwtCookieValue) {
        cachedAuthToken = null;
        cachedJwtCookieValue = null;
        return null;
    }

    if (cachedAuthToken && cachedJwtCookieValue === currentJwtCookieValue) {
        return cachedAuthToken;
    }

    if (!tokenRequestPromise) {
        tokenRequestPromise = $fetch('/api/auth/direct-token', {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response?.token || null)
            .catch(() => null)
            .finally(() => {
                tokenRequestPromise = null;
            });
    }

    const token = await tokenRequestPromise;
    cachedAuthToken = token;
    cachedJwtCookieValue = currentJwtCookieValue;
    return token;
};

export const useDirectApiFetchOptions = (options = {}) => {
    const {
        headers,
        credentials = 'include',
        ...rest
    } = options;

    const finalHeaders = {
        ...(headers || {}),
    };

    return {
        ...rest,
        credentials,
        ...(Object.keys(finalHeaders).length ? { headers: finalHeaders } : {}),
    };
};

export const useDirectApiFetch = async (path, options = {}) => {
    const { includeAuthHeader = true, ...rest } = options;
    const finalOptions = useDirectApiFetchOptions(rest);

    if (includeAuthHeader) {
        const authToken = await useDirectApiAuthToken();

        if (authToken) {
            finalOptions.headers = {
                ...(finalOptions.headers || {}),
                Authorization: `Bearer ${authToken}`,
            };
        }
    }

    return $fetch(useDirectApiUrl(path), finalOptions);
};
